import { render, staticRenderFns } from "./ListChamados.vue?vue&type=template&id=37526145&scoped=true"
import script from "./ListChamados.vue?vue&type=script&lang=js"
export * from "./ListChamados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37526145",
  null
  
)

export default component.exports